import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { TextField, TextFieldProps } from '@anytag/shared-molecules';

import { MarketplaceFormValues, MarketplaceFormKeys } from '../types';

export const CostPerClickField = (props: Omit<TextFieldProps, 'name'>) => {
  const { t } = useTranslation();
  const { watch } = useFormContext<MarketplaceFormValues>();
  const currency = watch(MarketplaceFormKeys.currency);

  return (
    <TextField
      rightSection={t(currency)}
      placeholder="0.1"
      help={t('Tooltip.Cost Click Help')}
      title={t('TextForm.Cost per Click')}
      name={MarketplaceFormKeys.costPerClick}
      {...props}
    />
  );
};
